import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSimpleAuth } from '../../contexts/SimpleAuthContext';
import { hasValidSessionInStorage } from '../../utils/authUtils';

/**
 * ใช้ครอบหน้า signup/signin ที่ต้องการให้เฉพาะผู้ที่ยังไม่ล็อกอินเท่านั้นเข้าได้
 * ถ้าผู้ใช้ล็อกอินอยู่แล้ว จะ redirect ไปหน้าตาม role
 * ใช้ storage เป็น source of truth เพื่อไม่ให้ memory ค้างหลัง ProtectedRoute ลบ token
 */
const GuestOnlyRoute = ({ children }) => {
  const { user, loading } = useSimpleAuth();
  const location = useLocation();

  if (loading) {
    return children;
  }

  const sessionValid = hasValidSessionInStorage();
  if (!sessionValid || !user) {
    return children;
  }

  const role = (user.role || '').toLowerCase();
  if (role === 'admin') {
    return <Navigate to="/admin" replace state={{ from: location }} />;
  }
  if (role === 'trainer' || role === 'เทรนเนอร์') {
    return <Navigate to="/trainer" replace state={{ from: location }} />;
  }
  if (
    role === 'customer' ||
    role === 'client' ||
    role === 'member' ||
    role === 'user' ||
    role === 'ลูกค้า' ||
    role === 'สมาชิก'
  ) {
    return <Navigate to="/client" replace state={{ from: location }} />;
  }
  return <Navigate to="/" replace state={{ from: location }} />;
};

export default GuestOnlyRoute;
